module.exports = __webpack_public_path__ + "img/quizz-step-4-4.c8600bf0.jpg";